@use '@design/design-tokens/typography/typography' as *;

.moreInsights {
  background-color: var(--surface-default);
  border-radius: 4px;
  padding: 2px 6px;
  height: fit-content;
  margin-left: 8px;
}

.count {
  color: var(--text-soft);
  @include typography-v2-body-xs;
  vertical-align: middle;
  display: block;
}
